import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    background: "bg-neutral-100 py-4 md:py-5 lg:py-6",
    wrapper: "",
    heading: "",
    backLink: "",
    emptyCart: ""
  },
  variants: {}
}), r = {
  main: t
}, o = e({
  slots: {
    wrapper: ""
  },
  variants: {}
}), s = e({
  slots: {
    headingWrapper: "",
    wrapper: "flex flex-col gap-4 items-center bg-white max-w-2xl w-full mx-auto p-4 lg:p-8 rounded-lg overflow-x-hidden mb-8 [&>div]:w-full",
    termsAndCondition: "flex items-center text-body-sm",
    newsletterBox: "flex items-center text-body-sm",
    standardCheckbox: ""
  },
  variants: {}
}), a = e({
  slots: {
    wrapper: "flex flex-col w-full",
    row: "flex items-center",
    label: "font-bold hidden",
    value: "ml-2 text-body-sm"
  },
  variants: {}
}), n = e({
  slots: {
    base: "flex flex-col gap-4 items-center bg-white max-w-2xl w-full mx-auto p-4 lg:p-8 rounded-lg overflow-x-hidden mb-8 [&>div]:w-full"
  },
  variants: {}
}), d = e({
  slots: {
    base: "appearance-none grid grid-cols-[repeat(12,_fr)] p-4 border-2 border-solid data-[is-active=true]:border-system-success rounded-lg w-full",
    label: "col-start-3 col-end-11 text-left text-heading-sm",
    logo: "col-start-2 col-end-3 text-center",
    activeIcon: "col-start-1 col-end-2 text-center border-2 border-solid border-system-success rounded-full w-4 h-4 place-self-center",
    usps: "col-start-3 col-end-11 text-left text-body-xs mt-2 gap-0.5 flex flex-col",
    usp: "",
    price: "col-start-11 col-end-13 text-heading-sm row-start-1 row-end-3 text-right place-self-stretch",
    shippingBarometer: ""
  },
  variants: {}
}), c = e({
  slots: {
    base: "flex flex-col gap-4 items-center bg-white max-w-2xl w-full mx-auto p-4 lg:p-8 rounded-lg overflow-x-hidden mb-8",
    headingWrapper: "mb-4"
  },
  variants: {}
});
export {
  s as addressFormBlueprint,
  a as addressSummaryBlueprint,
  r as checkoutBlueprint,
  o as checkoutDisclaimerBlueprint,
  n as checkoutPaymentWrapperStyling,
  d as shippingMethodOptionStyling,
  c as shippingMethodsStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
